module.exports = __webpack_public_path__ + "static/img/pCloud.b09977b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/drive/logo/pCloud.svg
// module id = /32x
// module chunks = 1